module.exports = __webpack_public_path__ + "226eed57ceb3cadf749a9d46461f1fd1.png";